// #region imports

// --- Angular
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';

// --- RxJs
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

// --- HS Code
import { SelectListItem } from '../../models';

// #endregion

@Component({
  selector: 'hs-autocomplete-box',
  templateUrl: './autocomplete-box.component.html',
  styleUrls: ['./autocomplete-box.component.scss'],
})
export class AutocompleteBoxComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit
{
  formControl: FormControl;

  @Input() noResultsLabel: string = '';
  @Input() list: SelectListItem[] | null = null;
  @Input() hideSearch: boolean = false;
  @Input() isNumeric: boolean=false;

  @Output() selectItem = new EventEmitter<string>();

  @ViewChild('autoCompleteField', { static: false })
  autoCompleteField: ElementRef<HTMLInputElement> | undefined;

  private _list$: BehaviorSubject<SelectListItem[]>;
  get list$(): Observable<SelectListItem[]> {
    return this._list$;
  }

  filteredOptions$: Observable<SelectListItem[]> | undefined;

  constructor() {
    this.formControl = new FormControl('');
    this._list$ = new BehaviorSubject(new Array<SelectListItem>());
  }

  ngOnInit() {
    this.filteredOptions$ = combineLatest([
      this.list$,
      this.formControl.valueChanges.pipe(startWith('')),
    ]).pipe(
      map(([list, value]) => {
        return this._filter(list, value);
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['list'] && changes['list'].currentValue) {
      this._list$.next(changes['list'].currentValue);
    }
  }

  ngOnDestroy() {}

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.autoCompleteField) {
        this.autoCompleteField.nativeElement.focus();
      }
    });
  }

  onSelectItem(value: string) {
    this.selectItem.emit(value);
  }

  private _filter(
    list: SelectListItem[] = [],
    value: string = ''
  ): SelectListItem[] {
    const filterValue = this._normalizeValue(value);
    return list.filter((d) =>
      this._normalizeValue(d.text).includes(filterValue)
    );
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }
}
